export const accessoryModal = [
  {
    type: 'title',
    content: 'Delivery Methods'
  },
  {
    type: 'paragraph',
    content: [
      '',
      'Suggested delivery method(s) will automatically be applied to the items in your cart',
    ]
  },
  {
    type: 'paragraph',
    content: [
      'Standard Shipping',
      'We ship to street addresses in the continental U.S., Alaska, and Hawaii. Because most items are delivered via FedEx, we cannot deliver to PO boxes or APO/FPO addresses.',
    ]
  },
  {
    type: 'styledTable',
    content: {
      title: '',
      rows: [
        [
          [
            'Order Total',
          ],
          [
            'Shipping',
          ],
        ],
        [
          ['Up to $50'],
          ['$9.95'],
        ],
        [
          ['$50.01 - $150'],
          ['$14.95'],
        ],
        [
          ['$150.01 - $250'],
          ['$27.95'],
        ],
        [
          ['$250.01 - $350'],
          ['$37.95'],
        ],
        [
          ['$350.01 - $450'],
          ['$47.95'],
        ],
        [
          ['$450.01 - $650'],
          ['$67.95'],
        ],
        [
          ['$650.01 - $850'],
          ['$87.95']
        ],
        [
          ['$850.01 - $1000'],
          ['$97.95']
        ],
        [
          ['$1,000.01 and over'],
          ['10% of Merchandise Total']
        ],
      ]
    }
  },
  {
    type: 'link',
    content: {
      title: 'Learn More',
      url: '/faq/#shipping-delivery'
    }
  }
]
